/**
 * clearable_choice_controller.js — lets an optional segmented control be
 * switched off (Stimulus, identifier "clearable-choice").
 *
 * Markup comes from segmented(..., clearable=True) in
 * templates/macros/segmented.html: radio chips plus one hidden radio whose
 * value is "" (the `none` target). A radio cannot be unticked by the browser,
 * so tapping the chip that is already lit ticks the hidden one instead, and
 * the form posts "" for "cleared". Every other tap is left to the browser.
 *
 * The check runs on the label's click, before the browser forwards it to the
 * radio, so `checked` still says whether the chip was lit before this tap.
 * Wired only through data-action, so there is nothing to tear down.
 */
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["none"];

    toggle(event) {
        const radio = document.getElementById(event.currentTarget.htmlFor);
        if (!radio || !radio.checked) return;
        event.preventDefault();
        this.noneTarget.checked = true;
        this.noneTarget.dispatchEvent(new Event("change", { bubbles: true }));
    }
}
